<template>
  <b-form-group
    label="Şube"
    label-for="branch"
  >
    <b-form-input
      id="branch"
      v-model="dataItem.branch"
      placeholder="Şube"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'Branch',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
}
</script>
